import { useState } from "react";
import emailjs from '@emailjs/browser';

export function Contacto() {
  const [form, setForm] = useState({ nombre: "", email: "", mensaje: "", time: "" });
  const [aceptaPrivacidad, setAceptaPrivacidad] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleChange(e: any) { 
    setForm({ ...form, [e.target.name]: e.target.value }); 
  }

  function handleSubmit(e: any) {
    e.preventDefault();
    
    if (!aceptaPrivacidad) {
      alert("Debes aceptar la política de privacidad para continuar.");
      return;
    }

    setLoading(true);

    emailjs.send(
      'service_n7nq1by',
      'template_2uq7n5h',
      {
        from_name: form.nombre,
        name: form.nombre,
        email: form.email,
        message: form.mensaje,
        time: new Date().toISOString(),
      },
      'zR_oKdJPGfrIIAowD'
    )
    .then(() => {
      alert("¡Mensaje enviado con éxito!");
      setForm({ nombre: "", email: "", mensaje: "", time: new Date().toISOString() });
      setAceptaPrivacidad(false);
      setLoading(false);
    })
    .catch((error) => {
      alert("Error al enviar el mensaje. Intenta de nuevo.");
      console.error(error);
      setLoading(false);
    });
  }

  return (
    <section id="contacto" className="pb-12 pt-20 bg-gradient-to-b from-clases-secondary to-clases-primary text-white">
      <div className="container mx-auto max-w-4xl px-6">
        <div className="flex flex-col md:flex-row gap-8 items-start"> 
          <div className="container mx-auto max-w-4xl px-6">  
            <h2 className="text-2xl font-semibold mb-6">Contacto</h2>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <input 
                name="nombre" 
                className="p-3 rounded bg-blue-50 text-gray-900" 
                placeholder="Nombre" 
                onChange={handleChange} 
                value={form.nombre} 
                required 
              />
              <input 
                name="email" 
                className="p-3 rounded bg-blue-50 text-gray-900" 
                placeholder="Email" 
                type="email" 
                onChange={handleChange} 
                value={form.email} 
                required 
              />
              <textarea 
                name="mensaje" 
                className="p-3 rounded bg-blue-50 text-gray-900" 
                placeholder="Mensaje" 
                rows={4} 
                onChange={handleChange} 
                value={form.mensaje} 
                required 
              />
              
              {/* Checkbox de consentimiento - OBLIGATORIO PARA GDPR */}
              <label className="flex items-start gap-3 text-sm cursor-pointer">
                <input 
                  type="checkbox" 
                  checked={aceptaPrivacidad}
                  onChange={(e) => setAceptaPrivacidad(e.target.checked)}
                  className="mt-1 w-4 h-4 cursor-pointer"
                  required
                />
                <span>
                  He leído y acepto la{' '}
                  <a 
                    href="/privacidad" 
                    target="_blank"
                    className="underline hover:text-blue-300"
                  >
                    política de privacidad
                  </a>
                  {' '}y autorizo el tratamiento de mis datos para responder a mi consulta.
                </span>
              </label>          
              <button 
                type="submit" 
                disabled={loading || !aceptaPrivacidad}
                className="bg-blue-800 hover:bg-white hover:text-blue-900 px-6 py-3 rounded text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed transition"
              >
                {loading ? "Enviando..." : "Enviar"}
              </button>
            </form>  
          </div>
          <div className="container mx-auto max-w-4xl"> 
            <h2 className="text-2xl font-semibold ">Localización</h2>
            <h3 className="text-l pb-2">AMPA Sanse</h3>
            <iframe 
              title="AMPA Sanse"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d314.367751143792!2d-16.251226002457418!3d28.462993808445948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc41cb7d499206cd%3A0xfd81345b8b04f185!2sIES%20Alcalde%20Bernab%C3%A9%20Rodr%C3%ADguez!5e0!3m2!1ses!2ses!4v1770293003319!5m2!1ses!2ses" 
              width="100%" 
              height="360" 
              style={{ border: "0" }}
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

/**
 * Para EMAILJS, se necesita:
 * Public Key: zR_oKdJPGFRuIAowD
 * Template ID: template_to20joka
 * Service ID: service_3lar548i
 * 
 * Esto son ejemplos solo
 */